export default __webpack_public_path__ + "media/Number2.5f5a441f932c63aba51c55d542790f2e.mp4";